import React from 'react';

class If extends React.Component {
    render() {
        return (this.props.predicate) ? this.props.children : null;
    }
}

export default If;
